<template>
    <v-card class="elavation-1 mb-20">
        <v-toolbar flat height="40px" @click="historyVisible=!historyVisible" title="Activity History" class="clickable">
            <v-icon>history</v-icon>
            <b class="ml-10">ACTIVITY HISTORY</b>
            <v-spacer></v-spacer>
            <v-btn v-if="historyVisible" icon title="Minimize">
                <v-icon>expand_less</v-icon>
            </v-btn>
            <v-btn v-if="!historyVisible" icon title="Expand">
                <v-icon>expand_more</v-icon>
            </v-btn>
        </v-toolbar>
        <p v-if="error" class="red--text">{{errorMessage}}</p>
        <div v-if="historyVisible">
           <v-data-table
                :items="update_history_data"
                :hide-actions="update_history_data.length<6"
                hide-headers
            >
                <template v-slot:no-data>
                    <div class="caption text-xs-center">No activities found</div>
                </template>
                <template v-slot:items="props">
                    <tr>
                        <td>
                            <div  style="margin:5px 0px 0px -15px;">
                                <v-chip small>
                                    <v-avatar size="30">
                                        <v-img ref="avatar" :src="getAvatarUrl(props.item)"></v-img>
                                    </v-avatar>
                                    {{props.item.createdByName}}
                                </v-chip>                            
                                <span :title="props.item.createdOn|moment('MMM DD, YYYY hh:mma')">{{ formatDate(props.item.createdOn) }}</span>
                            </div>
                            <div style="margin:5px 0px 5px 0px;">{{props.item.updateAction}}</div>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>
    </v-card>
</template>
<script>

import updateHistoryApi from '@/api/updateshistory'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'

export default {
    components: {},
    data() {
        return {
            error: false,
            errorMessage: null,
            loading: false,
            update_history_data: [],
            historyVisible: userPrefs.getExpandCollapseVisibility(this.$route.name, 'update-history'),
        }
    },
    props: ['page_query_id'],
    methods: {
        async getHistory() {
            try {
                this.loading = true
                const response = await updateHistoryApi.get(this.page_query_id)
                if (response.status == 200) {
                    this.update_history_data = response.data.items
                }
                 this.loading = false
            }
            catch (error) {
                this.error = true
                this.errorMessage = error
            }
        },
        formatDate(dt) {
            var duration = this.$moment.duration(this.$moment(Date.now()).diff(this.$moment(dt)))

            if (duration.years() > 0) return `on ${this.$moment(dt).format('MMM DD, YYYY')}`
            if (duration.months() > 0) return `on ${this.$moment(dt).format('MMM DD')}`
            if (duration.days() > 0) {
                var txt = duration.days()==1?'day ago':'days ago'
                return `${duration.days()} ${txt}`
            }
            if (duration.hours() > 0) {
                var txt = duration.hours()==1?'hour ago':'hours ago'
                return `${duration.hours()} ${txt}`
            }
            if (duration.minutes() > 0) {
                var txt = duration.minutes()==1?'minute ago':'minutes ago'
                return `${duration.minutes()} ${txt}`
            }
            return 'Just now'
        },
        getAvatarUrl(data) {
            //lightweight workaround to pull SweldoNow Employees avatar when viewed from customer's account
            //Pages such as Company Billing page
            //For now only SweldoNow Billing (billing@sweldonow.ph) will be used to manage customer's billing processing
            //This can be refactored in the future
            if (data.createdByName == 'SweldoNow Billing') {
                return awsS3Helper.getSweldoNowAvatarUrl(data.createdBy)
            }else{
                return awsS3Helper.getAvatarUrl(data.createdBy)
            }
        }
    },
    watch: {
        historyVisible(newVal) {
            userPrefs.updateExpandCollapseVisibility(this.$route.name, 'update-history', newVal)
        }
    },
    created() {
        this.getHistory()
    },
}
</script>
